<section class="page-title-area">
    <div class="container">
        <div class="page-title-content" *ngFor="let pageTitle of pageTitleArea;">
            <h2>{{pageTitle.title}}</h2>
            <ul>
                <li><a routerLink="/">Home</a></li>
                <li>{{pageTitle.title}}</li>
            </ul>
        </div>
    </div>

    <div class="shape-img1"><img src="assets/img/shape/shape1.svg" alt="image"></div>
    <div class="shape-img2"><img src="assets/img/shape/shape2.png" alt="image"></div>
    <div class="shape-img3"><img src="assets/img/shape/shape3.png" alt="image"></div>
</section>

<section class="events-area pt-100 pb-70">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-sm-6 col-md-6" *ngFor="let singleEventsContent of singleEvents;">
                <div class="single-events-box">
                    <div class="image">
                        <a routerLink="/events-details" class="d-block">
                            <img [src]="singleEventsContent.img" alt="image">
                        </a>
                        <span class="date">{{singleEventsContent.date}}</span>
                    </div>

                    <div class="content">
                        <h3><a routerLink="/events-details">{{singleEventsContent.title}}</a></h3>
                        <span class="location"><i class="bx bx-map"></i>{{singleEventsContent.location}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>